// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-bw\" viewBox=\"0 0 640 480\"> <g fill-rule=\"evenodd\"> <path fill=\"#00cbff\" d=\"M0 0h640v480H0z\"/> <path fill=\"#fff\" d=\"M0 160h640v160H0z\"/> <path d=\"M0 186h640v108H0z\"/> </g> </svg> ";
// Exports
module.exports = code;